import { useEffect, useState } from 'react';
import './App.css';
import  Captcha from './Captcha'
import { Form } from './Form';

function App() {
  const [completed, setCompleted] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    if (loading) {
        setTimeout(function() {
            setLoading(false);
            setSubmitted(true);
        }, 3500);
    }
  }, [loading])

  if (!completed) {
    return (
      <div>
        <Form submitted={loading} setSubmitted={setLoading}/>

        {submitted && !loading ?
          <div className="captcha-popup">
            <Captcha completed={completed} setCompleted={setCompleted}/>
          </div> : <div /> 
        }

        {loading &&
          <div className="popup">
            <div className="loading-container" style={{width: 300}}>
              <div className="loading loading--full-height"></div>
              <div className="loading-text">Generating reeeeCaptsha&trade; technology :D</div>
            </div>
          </div>
        }
      </div>
      
    )
  }
  else {
    return (
      <div>
        <div id="websiteOverlay">
          <h1>Bearbetar anmälan...</h1>
        </div>
        <div id="endContainer">
          <h1>Tyvärr, anmälningslistan är full. Vi ses nästa år!</h1>
        </div>
      </div>
    )
  }

}
export default App;
